export const _setTimeBlockV2PaginationData = (state, action) => {
  state.timeBlockV2PaginationData = [
    ...state.timeBlockV2PaginationData,
    action.payload,
  ];
};

export const _setTimeBlockV2PreviousKey = (state, action) => {
  state.timeblockV2PreviousKey = action.payload;
};

export const _setTimeBlockV2PaginationKey = (state, action) => {
  state.timeBlockV2PaginationKey = action.payload;
};
